// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"58b0d6ef","441":"81b635ac","581":"e8495187","597":"dd4ed3e1","887":"9023299f","909":"96a9921f"}[chunkId] + ".css";
};